import { z } from 'zod';

/**
 * 送付先住所編集フォームのバリデーションスキーマ
 *
 * 全フィールド必須。住所の自動補完は実装しない（チケット仕様）。
 */
export const editFormSchema = z.object({
  /**
   * 利用人数（従業員数）
   * テキスト入力の値をそのまま文字列で保持し、1 以上の整数の文字列のみ許容する。
   * 数値への変換は generatePatchRequestBody で行う（prefectureCode と同じ扱い）。
   */
  employeeCount: z
    .string()
    .trim()
    .min(1, '利用人数を入力してください。')
    .regex(/^[1-9]\d*$/, '1以上の整数で入力してください。'),
  /**
   * 郵便番号（ハイフンなし7桁）
   */
  postalCode: z
    .string()
    .trim()
    .regex(/^\d{7}$/, '郵便番号は7桁の数字で入力してください。'),
  /**
   * 都道府県コード（JIS X 0401、2桁の数字。Select の value として文字列で保持する）
   * generatePatchRequestBody で Number() に変換するため、2桁の数字であることをここで担保する。
   * "00" は prefecture_id: 0 になるため除外する（コードの実在チェックまでは行わない）
   */
  prefectureCode: z
    .string()
    .min(1, '都道府県を選択してください。')
    .regex(/^(?!00)\d{2}$/, '都道府県を選択してください。'),
  /**
   * 市区町村
   */
  city: z.string().trim().min(1, '市区町村を入力してください。'),
  /**
   * 番地以降の住所
   */
  streetAddress: z.string().trim().min(1, '番地以降の住所を入力してください。'),
});

export type EditFormFieldValues = z.infer<typeof editFormSchema>;
